export default "__VITE_ASSET__C4KZwP1e__"